import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import StickyHeader from 'components/StickyHeader'
import StickyHeaderWrapper from 'components/common/StickyHeaderWrapper'
import { FOOTER } from 'constant'
import MainSearchResult from './components/MainSearchResult'

const OneColumnSearchResultPage = ({
  placeholders: {
    header,
    footer,
    mainContent
  } = {}
}) =>
  <Fragment>
    <StickyHeaderWrapper>
      { header }
      <StickyHeader />
    </StickyHeaderWrapper>
    <MainSearchResult>
      { mainContent }
    </MainSearchResult>
    <div id={ FOOTER }>
      { footer }
    </div>
  </Fragment>

OneColumnSearchResultPage.propTypes = {
  placeholders: PropTypes.shape()
}

OneColumnSearchResultPage.type = 'OneColumnSearchResultPage'
OneColumnSearchResultPage.placeholders = ['header', 'mainContent', 'footer']

export default OneColumnSearchResultPage
